export default "__VITE_ASSET__BF3RCORI__"